var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { attrs: { shadow: _vm.fromType === 4 ? "never" : "always" } },
        [
          _vm.getFormConfig && _vm.fromType !== 4
            ? _c(
                "div",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.clearPLabel(_vm.getFormConfig.label)
                      ),
                    },
                  }),
                  _vm.sameUnitData &&
                  _vm.sameUnitData.visible === 1 &&
                  _vm.fromType !== 3
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.sameUnitData.options
                              ? _vm.sameUnitData.options[0].popover ||
                                "被保企业和投保企业为同一企业"
                              : "保司要求投保企业与被保企业必须为同一单位！",
                            disabled: _vm.sameUnitData.disabled !== 2,
                            effect: "light",
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { float: "right", padding: "4px 0" },
                              attrs: {
                                disabled: _vm.sameUnitData.disabled !== 2,
                              },
                              on: { change: _vm.onSameUnitChange },
                              model: {
                                value: _vm.unitFormData.same,
                                callback: function ($$v) {
                                  _vm.$set(_vm.unitFormData, "same", $$v)
                                },
                                expression: "unitFormData.same",
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.sameUnitData.options
                                      ? _vm.sameUnitData.options[0].label
                                      : "被保企业同投保企业"
                                  ) +
                                  "\n\t\t\t\t"
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.isShowAlert && _vm.fromType !== 4
            ? _c("el-alert", {
                staticStyle: { "margin-bottom": "10px" },
                attrs: {
                  title: _vm.isShowAlert,
                  "show-icon": "",
                  type: "warning",
                },
              })
            : _vm._e(),
          _c(
            "avue-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoading,
                  expression: "isLoading",
                },
              ],
              ref: "refUnitForm",
              attrs: {
                option: _vm.unitOption,
                "upload-after": _vm.uploadAfter,
                "upload-before": _vm.onUploadBefore,
              },
              on: { submit: _vm.onSubmitUnit },
              scopedSlots: _vm._u([
                {
                  key: "menuForm",
                  fn: function (ref) {
                    return [
                      !_vm.unitOption.submitBtn
                        ? _c(
                            "el-button",
                            {
                              attrs: { icon: "el-icon-edit" },
                              on: {
                                click: function ($event) {
                                  return _vm.onCheckUnitResult(false)
                                },
                              },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.unitFormData,
                callback: function ($$v) {
                  _vm.unitFormData = $$v
                },
                expression: "unitFormData",
              },
            },
            [
              !_vm.isRenBao(_vm.insureType)
                ? _c("el-autocomplete", {
                    ref: "refUnitName",
                    staticStyle: { width: "100%" },
                    attrs: {
                      slot: "name",
                      debounce: 300,
                      disabled: !_vm.unitOption.submitBtn,
                      "fetch-suggestions": _vm.querySearch,
                      "trigger-on-focus": true,
                      clearable: "",
                      placeholder: "请填写 企业名称",
                    },
                    on: {
                      clear: _vm.onUnitNameClear,
                      select: _vm.onChoiceUnit,
                    },
                    slot: "name",
                    model: {
                      value: _vm.unitFormData.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.unitFormData, "name", $$v)
                      },
                      expression: "unitFormData.name",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("InsureNotices", {
        ref: "refInsureNotices",
        on: {
          onToInsure: _vm.onGoInsure,
          onToSure: _vm.onToSure,
          onToSureEnd: _vm.onToSure,
        },
      }),
      _c("DialogGetiHint", {
        ref: "refGetTiHint",
        on: { onGetiSure: _vm.onGetiSure },
      }),
      _c("XsmYinLiuDialog", {
        ref: "refXsmYinLiu",
        on: { onShowInsureHint: _vm.onShowInsureHint },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }